let API_BASE_URL = '';
let LOGIN_URL = '';

export function setAPIBaseURL(url) {
  API_BASE_URL = url;
}

export function getAPIBaseURL() {
  return API_BASE_URL;
}

export function setLoginURL(url) {
  LOGIN_URL = url;
}

export function getLoginURL() {
  return LOGIN_URL;
}